import { Injectable, inject } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import {
  Section,
  SettingsBoolean,
  SettingsSections,
  SystemSettingsService
} from '@core/services/settings/system-settings.service';
import { map } from 'rxjs/operators';

/**
 * Resolves system settings
 * The activated route data subscription will return the resolved data as a zeroith entity
 * Example from OB report use-case: { 0: { show_long_ar_aging_buckets: false, display_biller_code_field: false } }
 */
@Injectable({
  providedIn: 'root'
})
export class SystemSettingsResolver {
  private systemSettingService = inject(SystemSettingsService);

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<{ [key: string]: boolean | string }> {
    const {
      data: { systemSettings }
    } = route;
    return this.systemSettingService.settings.pipe(
      map((settings: SettingsSections[]) => {
        this.systemSettingService.nouns = settings.filter((s) =>
          s.field.includes('_noun')
        );
        const settingsEnabled: { [key: string]: boolean | string } = {};
        for (const settingKey of systemSettings) {
          const settingMatching: Section<SettingsBoolean> | Section<string> =
            settings.find((s) => s.field === settingKey);
          if (settingMatching) {
            const { value } = settingMatching;
            if (value) {
              if (value === 'Y' || value === 'N') {
                const isEnabled: boolean = settingMatching
                  ? this.systemSettingService.getSystemSettingsBoolean(
                      settingMatching as Section<SettingsBoolean>
                    )
                  : false;
                if (isEnabled) settingsEnabled[settingKey] = true;
                else settingsEnabled[settingKey] = false;
              } else {
                // if (!(value instanceof String) || !(value instanceof Object)) {
                //     continue;
                // }
                settingsEnabled[settingKey] = value;
              }
            }
          }
        }
        return { ...settingsEnabled };
      })
    );
  }
}
